import React, { ChangeEvent, FormEvent, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormType } from '../../types/chat.types';
import { RootState } from '../../redux/store';

interface DynamicFormProps {
  forms: FormType;
  handleFormSubmit: (response: any, formFields?: any) => void;
}

const AdaptiveForm: React.FC<DynamicFormProps> = ({
  forms,
  handleFormSubmit,
}) => {
  const connectionStatus = useSelector(
    (state: RootState) => state.socketConnection.status,
  );
  const [formFields, setFormFields] = useState<string[]>(
    new Array(forms.formItem.length).fill(''),
  );

  const handleFieldChange = (index: number, value: string) => {
    const newFields = [...formFields];
    newFields[index] = value;
    setFormFields(newFields);
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    handleFormSubmit(forms.actionType, formFields);
  };

  return (
    <div className="m-3">
      <div className="mb-4 mx-3 text-left">{forms.label}</div>
      <div className="flex justify-between align-center mx-8 ">
        <form onSubmit={handleSubmit} className="w-4/5">
          {forms.formItem.map((value, index) => (
            <div key={index} className="my-4">
              <input
                type="text"
                placeholder={value.placeHolder}
                className="w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-3 bg-gray-100 border-2 border-gray-200 focus:border-primary rounded-lg py-2"
                value={formFields[index]}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleFieldChange(index, e.target.value)
                }
                disabled={connectionStatus !== 'Connected'}
              />
            </div>
          ))}

          <button
            type="submit"
            disabled={connectionStatus !== 'Connected'}
            className="ml-2 py-2 px-6 order-3 rounded-full bg-primary text-white enabled:hover:bg-secondary focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdaptiveForm;
